import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { isFeaturePresent } from '../util/CommonUtils';
import { GEOMAPPING_FEATUREID } from '../constants';
import GeoMapLanding from '../components/geoMap/GeoMapLanding';
import { addDDNHCSData, clearSampleWeightedKPIs, getSampleWeighted } from '../actions/crosstabActions';
import * as studyActions from '../actions/studyActions';
import * as dictionaryActions from '../actions/dictionaryActions';
import * as geoMappingActions from '../actions/geoMappingActions';
import NoStudyMessage from '../components/common/NoStudyMessage';
import { getGeoMapTableInfo, hasGeoDataInTable } from '../util/geomapUtils';
import { GEO_MAP_MODULE, GEOMAP_MODULE_NO_STUDIES_ERROR_MSG } from '../components/geoMap/GeoMapConstant';
import GeoMapTeaser from '../components/geoMap/GeoMapTeaser';
import { saveTrackingData } from '../util/trackerUtils';
import { PAGE_VISIT_GEOMAPPING, ADD_GEOMAPPING_TARGET, ADD_GEOMAPPING_BASE } from '../trackerConstants';

class GeoMap extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      sideBarChecked: false,
      hideWeightType: false,
      baseBtnDisabled: true,
      targetBtnDisabled: true,
    };
  }

  componentDidMount() {
    this.onMountMethod();
    setTimeout(() => {
      this.callSaveTrackerFn({
        action: PAGE_VISIT_GEOMAPPING,
        attributes: { hasAccess: this.props.hasModuleAccess },
      });
    }, 1000);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.kpiInfo !== this.props.kpiInfo) {
      if (nextProps.kpiInfo && nextProps.kpiInfo.intab) {
        this.setState({ targetBtnDisabled: false, baseBtnDisabled: false });
      } else {
        this.setState({ targetBtnDisabled: true, baseBtnDisabled: true });
      }
    }
  }

  onMountMethod = () => {
    const { loginResponse, geoMapStudy, geoMappingActions, activeAccountId } = this.props;
    if (loginResponse && this.checkPermission(GEOMAPPING_FEATUREID)) {
      if (geoMapStudy === undefined) {
        geoMappingActions.getGeoMappingStudies(
          loginResponse.data.token,
          loginResponse.data.uid,
          activeAccountId,
        );
      }
    }
  }

  getGridData = () => ({
    kpiInfo: this.props.kpiInfo,
    selectedReport: this.props.selectedReport,
    BaseDataGrid: this.props.geoMapBase,
    TargetDataGrid: this.props.geoMapTarget,
  })

  updateTargetSampleAndWeight = (gridName, updatedSmartSearch, targetInfo) => {
    // Case: 1 adding base when target is already added...
    const { loginResponse, activeAccountId, geoMapTarget, geoMapBase } = this.props;
    const TargetExpression = [];
    let baseExpressionList = updatedSmartSearch.current.props.gridData.kpiInfo.expressionList;
    if (gridName === 'BaseDataGrid' && geoMapTarget.length > 0) {
      if (baseExpressionList !== undefined) {
        const TargetExpressionVal = `(${geoMapTarget[0].keyword}) AND (${baseExpressionList})`;
        TargetExpression.push(TargetExpressionVal);
      } else {
        TargetExpression.push(geoMapTarget[0].keyword);
      }
      this.props.geoMappingActions.getUpdatedTargetSampleAndWeight(targetInfo,
        // loginResponse.data.token,
        loginResponse.data.uid,
        activeAccountId,
        this.props.geoMapStudy.pn,
        this.props.geoWeightTypes.wt,
        this.props.geoWeightTypes.dv,
        TargetExpression,
      );
    }

    // adding target when base is already added...
    if (gridName === 'TargetDataGrid' && (geoMapBase.length > 0)) {
      const TargetExpressionList = updatedSmartSearch.current
        .props.gridData.kpiInfo.expressionList;
      baseExpressionList = geoMapBase[0].keyword;
      if (baseExpressionList !== undefined) {
        const TargetExpressionVal = `(${TargetExpressionList}) AND (${baseExpressionList})`;
        TargetExpression.push(TargetExpressionVal);
      } else {
        TargetExpression.push(geoMapTarget[0].keyword);
      }
      this.props.geoMappingActions.getUpdatedTargetSampleAndWeight(targetInfo,
        // loginResponse.data.token,
        loginResponse.data.uid,
        activeAccountId,
        this.props.geoMapStudy.pn,
        this.props.geoWeightTypes.wt,
        this.props.geoWeightTypes.dv,
        TargetExpression,
      );
    }
  }

  resetAndUpdateGeoMapData = () => {
    const { geographicsTableData, geoMapTarget } = this.props;
    if (hasGeoDataInTable(geographicsTableData) && geoMapTarget && geoMapTarget.length > 0) {
      this.props.geoMappingActions.resetGeoMapTablesWithZerosAndApis().then(() => {
        const { selectedGeographicsTabIndex, countyCategorySelectedVal,
          zipcodeCategorySelectedVal, geographicsTableApiQueues, geoMapStudy,
          geoMapTarget, geoWeightTypes, loginResponse, activeAccountId } = this.props;
          this.props.geoMappingActions.updateGeoMapLoading(true)
        getGeoMapTableInfo(
          loginResponse,
          activeAccountId,
          geoMapStudy,
          geoWeightTypes,
          geoMapTarget,
          selectedGeographicsTabIndex,
          countyCategorySelectedVal,
          zipcodeCategorySelectedVal,
          geographicsTableApiQueues,
          this.props.geoMappingActions.getGeoghrapicsTableData,
          this.props.geoMappingActions.setGeoghrapicsTableApiCallStatus,
        );
      });
    }
  }


  handleGeoMapMove = (targetGrid, updatedSmartSearch) => {
    const {
      insight360PersonalLabels,
    } = updatedSmartSearch.current.state;
    updatedSmartSearch.current.handleSelectedIndexState();
    let targetInfo = {};
    const expression = this.props.kpiInfo.expressionList;
    const selectedNames = insight360PersonalLabels.join(' ');

    const basetargetInfo = {
      keyword: expression,
      originalTitle: selectedNames,
      sample: this.props.kpiInfo.intab,
      title: selectedNames,
      weighted: this.props.kpiInfo.weighted,
    };

    if (targetGrid === 'TargetDataGrid') {
      const targetInfoArr = {
        keyword: expression,
        originalTitle: selectedNames,
        sample: this.props.kpiInfo.intab,
        title: selectedNames,
        weighted: this.props.kpiInfo.weighted,
      };
      targetInfo = targetInfoArr;
    }

    if (targetGrid === 'BaseDataGrid' && this.props.geoMapTarget.length > 0) {
      targetInfo = this.props.geoMapTarget[0];
    }

    let action = '';
    switch (targetGrid) {
      case 'TargetDataGrid': action = ADD_GEOMAPPING_TARGET; break;
      case 'BaseDataGrid': action = ADD_GEOMAPPING_BASE; break;
      default: action = ''; break;
    }
    if (action !== '') {
      this.callSaveTrackerFn({ action, attributes: { expression: selectedNames } });
    }

    this.updateTargetSampleAndWeight(targetGrid, updatedSmartSearch, targetInfo);
    this.props.geoMappingActions.setOriginalTitle(targetGrid, { originalTitle: selectedNames });
    this.props.geoMappingActions.setGeoMapBaseTarget(basetargetInfo, targetGrid)
      .then(() => {
        updatedSmartSearch.current.resetAll();
        this.setState({ targetBtnDisabled: true, baseBtnDisabled: true });
        this.resetAndUpdateGeoMapData();
      });
  };

  handlesideBarToggle = () => {
    this.setState({ sideBarChecked: !this.state.sideBarChecked });
  }

  handleStudyChange = (val, updatedWeightType) => {
    this.clearCrossTabData();
    this.updateWeightType(updatedWeightType, val);
  }

  updateWeightType = (weightType, updatedStudy) => {
    const { studyActions, dictionaryActions } = this.props;
    studyActions.updateModuleStudy('geoMap', updatedStudy);
    dictionaryActions.clearTreeLoadNodeList();
    this.props.studyActions.updateWeightType(GEO_MAP_MODULE, weightType);
  }

  clearCrossTabData = () => {
    const {
      addDDNHCSData,
      clearSampleWeightedKPIs,
    } = this.props;
    addDDNHCSData([]);
    clearSampleWeightedKPIs();
  }

  callSaveTrackerFn = ({ action, attributes = undefined }) => {
    const productNo = this.props.geoMapStudy !== undefined ?
      this.props.geoMapStudy.pn : undefined;
    saveTrackingData({
      uid: this.props.loginResponse.data.uid,
      accid: this.props.activeAccountId,
      productNo,
      moduleName: 'GEOMAPPING',
      attributes,
      action,
    });
  }

  checkPermission(moduleFeature) {
    const { modulePermissions } = this.props;
    let hasFeature = false;
    if (modulePermissions.length > 0) {
      hasFeature = isFeaturePresent(moduleFeature, modulePermissions);
    }
    return hasFeature;
  }

  renderNoGeoMapStudiesMessage = () => {
    const { hasModuleAccess, hasGeoMapStudies } = this.props;
    if (!hasModuleAccess) {
      return <GeoMapTeaser data-test="NoPermissionComponent" />;
    }

    if (hasModuleAccess && !hasGeoMapStudies) {
      return (
        <NoStudyMessage message={GEOMAP_MODULE_NO_STUDIES_ERROR_MSG} data-test="NoStudyComponent" />
      );
    }
    return null;
  }

  renderGeoMap = () => {
    const {
      hasGeoMapStudies,
      hasModuleAccess,
      studies,
      geoMapStudy,
      getSampleWeighted,
      fetchKPI,
      studyActions,
    } = this.props;
    const { sideBarChecked, hideWeightType } = this.state;
    if (hasModuleAccess && hasGeoMapStudies) {
      return (
        <GeoMapLanding
          data-test="RenderGeoMapFunc"
          studies={studies}
          geoMapStudy={geoMapStudy}
          getSampleWeighted={getSampleWeighted}
          fetchKPI={fetchKPI}
          removeKPI={this.props.geoMappingActions.removeGeomapKpiInfo}
          gridData={this.getGridData()}
          handlesideBarToggle={this.handlesideBarToggle}
          sideBarChecked={sideBarChecked}
          updateModuleStudy={studyActions.updateModuleStudy}
          hideWeightType={hideWeightType}
          updateWeightType={this.updateWeightType}
          handleStudyChange={this.handleStudyChange}
          handleGeoMapMove={this.handleGeoMapMove}
          baseBtnDisabled={this.state.baseBtnDisabled}
          targetBtnDisabled={this.state.targetBtnDisabled}
          updateTargetSampleAndWeight={this.updateTargetSampleAndWeight}
          resetAndUpdateGeoMapData={this.resetAndUpdateGeoMapData}
          trackerFn={this.callSaveTrackerFn}
          exportSpinnerWarningInfoMsg={this.props.exportSpinnerWarningInfoMsg}
          exportSpinnerProgressFlag={this.props.exportSpinnerProgressFlag}

        />
      );
    }
    return null;
  }

  render() {
    return (
      <div data-test="GeoMapComponent">
        {this.renderNoGeoMapStudiesMessage()}
        {this.renderGeoMap()}
      </div>
    );
  }
}

GeoMap.propTypes = {
  geoMapStudy: PropTypes.shape({
    pn: PropTypes.number,
    wt: PropTypes.number,
    sd: PropTypes.string,
  }),
  loginResponse: PropTypes.shape({
    data: PropTypes.shape({
      uid: PropTypes.number,
      token: PropTypes.string,
    }),
  }),
  geoMappingActions: PropTypes.shape({
    runGeoMap: PropTypes.func,
    getSampleWeighted: PropTypes.func,
    setGeoMapBaseTarget: PropTypes.func,
    removeGeomapKpiInfo: PropTypes.func,
    getUpdatedTargetSampleAndWeight: PropTypes.func,
    resetGeoMapTablesWithZerosAndApis: PropTypes.func,
    getGeoghrapicsTableData: PropTypes.func,
    setGeoghrapicsTableApiCallStatus: PropTypes.func,
    setOriginalTitle: PropTypes.func,
    getGeoMappingStudies: PropTypes.func,
  }),
  hasModuleAccess: PropTypes.bool,
  hasGeoMapStudies: PropTypes.bool,
  studyActions: PropTypes.shape({
    updateWeightType: PropTypes.func,
    updateModuleStudy: PropTypes.func,
  }),
  dictionaryActions: PropTypes.shape({
    clearTreeLoadNodeList: PropTypes.func
  }),
  studies: PropTypes.instanceOf(Array),
  // weightTypeStudies: PropTypes.instanceOf(Array),
  kpiInfo: PropTypes.shape({
    intab: PropTypes.number,
    weighted: PropTypes.number,
    expressionList: PropTypes.string
  }),
  addDDNHCSData: PropTypes.func,
  clearSampleWeightedKPIs: PropTypes.func,
  fetchKPI: PropTypes.func,
  getSampleWeighted: PropTypes.func,
  activeAccountId: PropTypes.number,
  selectedReport: PropTypes.shape({}),
  geoMapBase: PropTypes.arrayOf(PropTypes.object),
  geoMapTarget: PropTypes.arrayOf(PropTypes.object),
  modulePermissions: PropTypes.instanceOf(Array),
  geoWeightTypes: PropTypes.shape({
    wt: PropTypes.number,
    dv: PropTypes.number,
  }),
  zipcodeCategorySelectedVal: PropTypes.string,
  countyCategorySelectedVal: PropTypes.string,
  geographicsTableApiQueues: PropTypes.instanceOf(Object),
  selectedGeographicsTabIndex: PropTypes.number,
  geographicsTableData: PropTypes.shape({}),
  getGeoMappingStudies: PropTypes.func,
  exportSpinnerProgressFlag: PropTypes.bool,
  exportSpinnerWarningInfoMsg: PropTypes.bool,
};

GeoMap.defaultProps = {
  hasGeoMapStudies: true,
  hasModuleAccess: false,
};

function mapStateToProps(state) {
  return {
    hasModuleAccess: isFeaturePresent(GEOMAPPING_FEATUREID, state.userDetail.permissions),
    hasGeoMapStudies: state.study.hasGeoMapStudies,
    studies: state.study.geoMapStudies,
    geoMapStudy: state.study.geoMapStudy,
    // weightTypeStudies: state.study.weightTypeStudies,
    // kpiInfo: state.crosstab.kpiInfo,
    kpiInfo: state.geomap.kpiInfo,
    loginResponse: state.login.loginResponse,
    activeAccountId: state.account.activeAccountId,
    selectedReport: state.geomap.selectedReport,
    geoMapTarget: state.geomap.TargetDataGridData,
    geoMapBase: state.geomap.BaseDataGridData,
    geoWeightTypes: state.study.geoWeightTypes,
    modulePermissions: state.userDetail.permissions,
    selectedGeographicsTabIndex: state.geomap.selectedGeographicsTabIndex,
    countyCategorySelectedVal: state.geomap.countyCategorySelectedVal,
    zipcodeCategorySelectedVal: state.geomap.zipcodeCategorySelectedVal,
    geographicsTableApiQueues: state.geomap.geographicsTableApiQueues,
    geographicsTableData: state.geomap.geographicsTableData,
    exportSpinnerProgressFlag: state.geomap.exportSpinnerProgressFlag,
    exportSpinnerWarningInfoMsg: state.geomap.exportSpinnerWarningInfoMsg,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    clearSampleWeightedKPIs: bindActionCreators(clearSampleWeightedKPIs, dispatch),
    addDDNHCSData: bindActionCreators(addDDNHCSData, dispatch),
    getSampleWeighted: bindActionCreators(getSampleWeighted, dispatch),
    // fetchKPI: bindActionCreators(fetchKPI, dispatch),
    // fetchKPI: bindActionCreators(fetchKPI, dispatch),
    studyActions: bindActionCreators(studyActions, dispatch),
    dictionaryActions: bindActionCreators(dictionaryActions, dispatch),
    geoMappingActions: bindActionCreators(geoMappingActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(GeoMap);
